import { Button } from "@mui/material";
import { FallbackProps } from "react-error-boundary";
import { normalizeError } from "@shared/lib/errors";

function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  const appError = normalizeError(error);

  return (
    <div role="alert" style={{ padding: "1rem" }}>
      <h2>אירעה שגיאה</h2>
      <p>{appError.userMessage}</p>
      {appError.retryable ? <Button onClick={resetErrorBoundary}>נסה שוב</Button> : null}
    </div>
  );
}

export default ErrorFallback;
